// extracted by mini-css-extract-plugin
export var hasTrail = "title-module--hasTrail--7a5cb";
export var title = "title-module--title--664c9";